<template>
  <div class="row">
    <div class="col-lg-12 color-black">
      <div
        v-for="(option, index) in choices.options"
        :key="index"
        style="width: fit-content"
      >
        <label class="pointer" style="overflow-wrap: break-word">
          <input
            v-if="choices.canMarkMoreThanOne"
            v-model="option.marked"
            type="checkbox"
            @click="set_answer(option)"
          />
          <input
            v-else
            v-model="choices.marked"
            :value="option.title"
            name="question_options"
            type="radio"
            @click="confirmChoice = true"
          />
          {{ option.title }}
        </label>
        <div v-if="option.hasSubanswer && option.marked">
          <label class="ml-4">
            {{ option.subanswerLabel }}
          </label>
          <div
            v-for="(suboption, subindex) in option.subanswers"
            :key="subindex"
            class="ml-5"
          >
            <label class="pointer" style="overflow-wrap: break-word">
              <input
                v-model="suboption.marked"
                type="checkbox"
                @click="set_subanswer(suboption, option)"
              />
              {{ suboption.title }}
            </label>
          </div>
        </div>
        <div
          v-if="option.specify && checkOptionMarked(option, choices)"
          class="mb-3"
        >
          <input
            v-model="option.specifyText"
            class="form-control"
            placeholder="Especifique"
            type="text"
          />
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-xs-12"></div>
    <div class="col-lg-4 col-xs-12">
      <transition name="fade">
        <button
          v-if="confirmChoice"
          class="btn btn-primary full"
          @click="saveAnswer"
        >
          Confirmar escolha
        </button>
        <div v-if="question.choices.canBeEmpty">
          <button class="btn btn-primary full mt-2" @click="skip">Pular</button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["question", "index", "currentTime", "is_evaluation", "answers"],
  data: () => ({
    choices: {
      canMarkMoreThanOne: false,
      marked: "",
      options: [],
    },
    confirmChoice: false,
  }),
  mounted() {
    this.choices = this.question.choices;
    this.choices.options.forEach((option) => {
      if (option.hasSubanswer) {
        option.subanswers = option.subanswer.split(";").map((suboption) => {
          return {
            title: suboption,
            marked: false,
          };
        });
      }
    });
    if (this.answers?.length > 0) {
      const answer = this.answers.find(
        (answer) => answer.question_id == this.question.id
      );
      if (answer) {
        this.marked = answer.choices.marked[0];
        this.confirmChoice = true;
      }
    }
  },
  watch: {
    question() {
      this.choices = this.question.choices;
      if (this.questions.choices.marked?.length > 0) {
        this.confirmChoice = true;
      } else {
        this.confirmChoice = false;
      }
    },
  },
  methods: {
    saveAnswer() {
      let data = this.answered(this.choices.options);
      if (data.empty_subanswers) {
        this.$toast.error("Por favor, preencha as subopções.");
        return;
      }

      if (data.specify_empty) {
        this.$toast.error("Por favor, especifique a sua resposta.");
        return;
      }

      if (data.is_over_limit) {
        this.$toast.error(
          `Por favor, selecione no máximo ${data.amount} opções`
        );
        return;
      }
      if (data.is_under_limit) {
        this.$toast.error(
          `Por favor, selecione no mínimo ${data.amount} opções`
        );
        return;
      }
      if (!data.answered) {
        let extra = this.choices.canMarkMoreThanOne ? "pelo menos" : "";
        this.$toast.error(`Por favor, selecione ${extra} uma das opções`);
        return;
      }

      let answers = {
        question_id: this.question.id,
        evaluation_id: this.question.evaluation_id,
        time_taken: this.currentTime,
        choices: {
          marked: data.titles,
          subanswers: data.subanswers,
        },
      };

      axios.post("/candidates/answers", { answers }).then((response) => {
        if (response.status) {
          if (this.is_evaluation) {
            this.$emit("saveAnswers", answers);
            this.$emit("nextQuestion", "true");
            return;
          }
          this.$emit("saveAnswers", answers);
          eventBus.$emit("nextQuestion", this.index);
        }
      });
    },
    skip() {
      if (this.is_evaluation) {
        this.$emit("nextQuestion", "true");
        return;
      }
      eventBus.$emit("nextQuestion", this.index);
    },
    answered(options) {
      let marked = [];
      let subanswers = [];

      for (const option of options) {
        const isMarked = this.choices.canMarkMoreThanOne
          ? option.marked
          : this.choices.marked === option.title;

        if (!isMarked) {
          continue;
        }

        if (this.choices.canMarkMoreThanOne) {
          marked.push(option.title);
        }

        if (option.specify) {
          if (!option.specifyText || !option.specifyText.trim()) {
            return { specify_empty: true };
          }
          subanswers.push({
            parent_option: option.title,
            marked: option.specifyText,
          });
        }

        if (option.hasSubanswer) {
          const selected_options = option.subanswers.filter(
            (suboption) => suboption.marked
          );
          if (selected_options.length === 0) {
            return { empty_subanswers: true };
          }
          selected_options.forEach((suboption) => {
            subanswers.push({
              parent_option: option.title,
              marked: suboption.title?.trim(),
            });
          });
        }
      }

      const choiceLimit = this.choices.choiceLimit;
      const choicesMin = this.choices.choicesMin;
      if (choiceLimit && marked?.length > choiceLimit) {
        return {
          is_over_limit: true,
          amount: choiceLimit,
        };
      }

      if (choicesMin && marked?.length < choicesMin) {
        return {
          is_under_limit: true,
          amount: choicesMin,
        };
      }

      const finalTitles = this.choices.canMarkMoreThanOne
        ? marked
        : this.choices.marked
        ? [this.choices.marked]
        : [];

      return {
        answered: finalTitles.length > 0,
        titles: finalTitles,
        subanswers: subanswers?.length > 0 ? subanswers : null,
      };
    },
    set_subanswer(suboption) {
      if (!suboption.marked) {
        suboption.marked = true;
      } else {
        suboption.marked = false;
      }
    },
    set_answer() {
      this.confirmChoice = true;
    },
    checkOptionMarked(option, choices) {
      if (!choices.canMarkMoreThanOne) {
        return choices.marked == option.title;
      }
      return option.marked;
    },
  },
};
</script>
